import React from 'react';
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import Header from '../../../../components/layout/headers/Header';
import UserRolesTable from './UserRolesTable';


const UserRoles = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <UserRolesTable/>
                </div>
            </div>
        </>
    )
}

export default UserRoles;